import Swiper from 'swiper'
import {Navigation, Parallax} from 'swiper/modules'

document.addEventListener('DOMContentLoaded', () => {
  const sliderWrappers = document.querySelectorAll('.mtt-image-link-boxes-slider')

  if (sliderWrappers.length > 0) {
    sliderWrappers.forEach(sliderWrapper => {
      const swiperElement = sliderWrapper.querySelector('.mtt-image-link-boxes-slider__swiper')
      const nextButton = sliderWrapper.querySelector('.swiper-next')
      const prevButton = sliderWrapper.querySelector('.swiper-prev')

      const swiperOptions = {
        modules: [Navigation],
        spaceBetween: 24,
        slidesPerView: 3,
        loop: false,
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton
        },
        breakpoints: {
          250: {
            slidesPerView: 1.1
          },
          400: {
            slidesPerView: 1.2
          },
          580: {
            slidesPerView: 1.5
          },
          650: {
            slidesPerView: 2,
          },
          1200: {
            slidesPerView: 3
          }
        }
      }

      const swiper = new Swiper(swiperElement, swiperOptions)
    })
  }
})
